import { isAuthenticationRequiredSyncError } from '@/lib/sync/error-utils';
import { syncTeamPresets } from '@/lib/sync/team-presets';
import type { UserId } from '@/schemas/ids';
import { enqueueSyncJob, registerSyncPlugin } from '../plugins.js';
import type { SyncPlugin } from '../plugins.js';

export const TEAM_PRESETS_SYNC_PLUGIN_KEY = 'team-presets';

const teamPresetsPlugin: SyncPlugin<UserId> = {
  key: TEAM_PRESETS_SYNC_PLUGIN_KEY,
  createJobKey(userId: UserId) {
    return `team-presets:${String(userId)}`;
  },
  createMetadata(userId: UserId) {
    return {
      entity: 'team-presets',
      scope: String(userId),
      source: 'team-presets-sync-plugin',
    };
  },
  async run(userId: UserId) {
    await syncTeamPresets(userId);
  },
  shouldRetry(error) {
    return !isAuthenticationRequiredSyncError(error);
  },
};

const registerTeamPresetsPlugin = registerSyncPlugin as (
  plugin: SyncPlugin<UserId>,
) => SyncPlugin<UserId>;
registerTeamPresetsPlugin(teamPresetsPlugin);

export function enqueueTeamPresetsSync(userId: UserId): void {
  const enqueue = enqueueSyncJob as (key: string, scope: UserId) => void;
  enqueue(TEAM_PRESETS_SYNC_PLUGIN_KEY, userId);
}
